import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface Event {
  start: string | Date;
  end: string | Date;
  timeDataTypeName: string;
  myTimeType: string;
  state?: string;
}

export const MyTimeCalendarTooltip = ({ event }: { event: Event }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const startTime = moment(event.start).format("HH:mm");
  const endTime = moment(event.end).format("HH:mm");

  const getColor = (label: string) => {
    switch (label) {
      case "requested":
        return "#F3AA18";
      case "approved":
        return "#2FA84F";
      case "rejected":
        return theme.palette.primary.main;
      default:
        return "";
    }
  };

  return (
    <Box
      style={{
        width: "226px",
        textAlign: "center",
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "0.4px",
      }}
    >
      <Box paddingBottom={"4px"}>{event.timeDataTypeName}</Box>
      <Box paddingBottom={"4px"}>{t(`MY_TIME_${event.myTimeType}`)}</Box>
      <Box
        style={{
          height: "1px",
          backgroundColor: "#A6ADAF",
          marginBottom: "4px",
        }}
      />
      <Box>{`${startTime} - ${endTime}`}</Box>
      {event.state && (
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          paddingTop="4px"
        >
          <Box width="50%" textAlign="right" paddingRight="2px">
            {t("OC_STATE")}
          </Box>
          <Box width="50%" padding="0px 6px">
            <Box
              style={{
                border: `1px solid ${getColor(event.state)}`,
                borderRadius: 12,
                padding: "2px 6px",
              }}
            >
              {t(`MY_LEAVE_${event.state.toUpperCase()}`)}
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default MyTimeCalendarTooltip;
